import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import ActivityBar from "../Reusable/ActivityBar/ActivityBar";
import SectionSlider from "../Reusable/SectionSlider/SectionSlider";
import { sectionsStrategyCreation, sectionsStrategyCreationPaths } from "../../constants/sectionData";
import GlobalPoliciesFileViewPopup from "../Reusable/Popup/GlobalPoliciesFileViewPopup";
import FileSection from "../Reusable/RiskSecurity/FileSelection";
import GPAdminFileViewPopup from "../Reusable/Popup/GPAdminFileViewPopup";
import StrategyFileSelection from "../Reusable/RiskSecurity/StrategyFileSelection";
import StrategyFileSelection2 from "../Reusable/RiskSecurity/StrategyFileSelection2";

interface CapexOpexSectionProps {
  isManager?: boolean;
  isAdmin?: boolean;
}

const CapexOpexSection: React.FC<CapexOpexSectionProps> = ({ isManager, isAdmin }) => {
  const management = localStorage.getItem("management") || "Default Location Name";
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedFileData, setSelectedFileData] = useState<any>(null);
  console.log("Selected File Data:", selectedFileData);
  const [selectedSectionName, setSelectedSectionName] = useState<string>("");

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  const handleFileUploadSuccess = () => {
    // Handle any logic after successful file upload
    console.log("File uploaded successfully");
  };

  const handleViewClick = (fileData: any, sectionName: string) => {
    setSelectedFileData(fileData); // Set the file data for the popup
    setSelectedSectionName(sectionName); // Set the section name for the popup
    setPopupOpen(true); // Open the popup
  };

  const breadcrumbs = [
    <Link key="1" to="/">
      Home
    </Link>,
    <Link key="2" to="/operations/strategy-value-creation/">
      Evidence Upload
    </Link>,
    <Link key="3" to="/operations/strategy-value-creation/">
      Value Creation through resources allocation
    </Link>,
    <Typography key="4">{management}</Typography>,
  ];

  return (
    <>
      <ActivityBar breadcrumbs={breadcrumbs} />
      <SectionSlider
        sections={sectionsStrategyCreation}
        sectionPaths={sectionsStrategyCreationPaths}
        highlightSection={"GBS CAPEX and OPEX Allocation"}
        highlightColor="#D7A833"
        defaultColor="#666"
      />

      {/* <Typography variant="h6" sx={{ fontWeight: '600', paddingLeft: '40px', fontSize: '16px' }}>Risks and Security</Typography> */}

      <Box className="titlecardrisk" sx={{ display: "flex", gap: "10px", padding: "24px", paddingLeft: "40px", }}>
        <StrategyFileSelection
          key="section1"
          sectionName="CAPEX Spend & Benefits"
          fileTitle="Please upload Planned CAPEX spend, Benefits and KPIs values for CAPEX projects impacting BSC are defined with the required granularity (e.g., type of costs, type of benefits) in line with CAPEX budgeting timelines. Zone documentation evidence should include detailed project business case. Global Anaplan tool - GHQ Zone Documentation - Portal."
          tabName="GBS CAPEX and OPEX Allocation"
          management={management}
          apiPath="/strategy/filter_strategy_n_value_creation"
          apiPathUpload="/strategy/strategy_n_value_creation"
          isManager={isManager}
          onFileUploadSuccess={handleFileUploadSuccess}
          onViewClick={({ fileData, sectionName, refresh }) => {
            setSelectedFileData({ ...fileData, refresh });
            setSelectedSectionName(sectionName);
            setPopupOpen(true);
          }}
         
         
        />

        <StrategyFileSelection2
          key="section2"
          sectionName="OPEX Reports"
          fileTitle="Please upload the OPEX report for People and Non-People BSC costs with the right granularity using the GBS template."
          tabName="GBS CAPEX and OPEX Allocation"
          management={management}
          apiPath="/strategy/filter_strategy_n_value_creation"
          apiPathUpload="/strategy/strategy_n_value_creation"
          isManager={isManager}
          onFileUploadSuccess={handleFileUploadSuccess}
          onViewClick={({ fileData, sectionName, refresh }) => {
            setSelectedFileData({ ...fileData, refresh });
            setSelectedSectionName(sectionName);
            setPopupOpen(true);
          }}
         
        />
      </Box>

      {/* File View Popup */}
      {isPopupOpen && isManager && selectedFileData && (
        <GlobalPoliciesFileViewPopup
          onClose={handleClosePopup}
          open={true}
          name={selectedFileData.file_name}
          id={selectedFileData.id}
          functionl1={selectedFileData.function_l1}
          date={selectedFileData.created_at}
          updatedBy={selectedFileData.updated_by}
          sectionTitle={selectedSectionName} // Dynamic section title
          userDetail={true}
          apiPath={`/strategy/strategy_n_value_creation/${selectedFileData.id}`}
        />
      )}

      {isPopupOpen && isAdmin && selectedFileData && (
        <GPAdminFileViewPopup
          onClose={handleClosePopup}
          open={true}
          name={selectedFileData.file_name}
          id={selectedFileData.id}
          status={selectedFileData.status}
          functionl1={selectedFileData.function_l1}
          date={selectedFileData.created_at}
          updatedBy={selectedFileData.updated_by}
          sectionTitle={selectedSectionName} // Dynamic section title
          apiPath={`/strategy/strategy_n_value_creation/${selectedFileData.id}`} // Pass the API path for file details
          statusApiPath="/strategy/strategy_n_value_creation_status" // Pass the API path for status updates
          reason_to_approve={selectedFileData.reason_to_approve}
          reason_to_revert={selectedFileData.reason_to_revert}
          onSuccess={selectedFileData.refresh}

        />
      )}
    </>
  );
};

export default CapexOpexSection;